import { DropDown } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { InputLabel } from '@mui/material';
import { memo, useMemo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { SelectLabelGroupingStatusProps as Props } from './types';
import { useSelectLabelGroupingStatus } from './use-select-label-grouping-status';

export const SelectLabelGroupingStatus = memo(
  ({ className, onChange, isLabel, hasLinkedinUrl }: Props) => {
    const { value, options, handleChange } = useSelectLabelGroupingStatus();

    const onValueChange = (newValue: string) => {
      const result = handleChange(newValue);
      onChange?.(result);
    };

    const labelText = useMemo(
      () =>
        hasLinkedinUrl
          ? 'Select Type:'
          : isLabel
          ? 'Select Label Type:'
          : 'Select List Type:',
      [isLabel, hasLinkedinUrl]
    );

    return (
      <Styled.Wrapper
        className={classnames('SelectLabelGroupingStatus', className)}
        sx={SX.root}
        fullWidth
      >
        <InputLabel shrink disableAnimation variant="outlined">
          {labelText}
        </InputLabel>

        <DropDown
          size="small"
          name="grouping"
          value={value}
          onChange={onValueChange}
          options={options}
        />
      </Styled.Wrapper>
    );
  }
);

SelectLabelGroupingStatus.displayName = 'SelectLabelGroupingStatus';
